import { OrthoMask } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateOrthoMaskArgs,
    getDefaultOrthoMaskCreateArgs,
    UpdateOrthoMaskArgs,
} from "@nova/serializer/src/client/validators/cubes/orthoMask"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"

const {
    create: createOrthoMask,
    update: updateOrthoMask,
    delete: deleteOrthoMask,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    OrthoMask,
    CreateOrthoMaskArgs,
    ["flightId", "polygon", "enabled", "createdBy"],
    UpdateOrthoMaskArgs
>("OrthoMask")

export const addOrthoMasksToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data } }, socket) => {
            const optimisticData = {
                id: randomUUID(),
                ...getDefaultOrthoMaskCreateArgs(),
                ...data,
            }
            createOrthoMask(socket, { ...data, id: optimisticData.id })
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["orthoMasks"],
                })
            )
        })
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateOrthoMask(socket, id, updates)
            store.dispatch(updateEntitySocket({ updates, path: ["orthoMasks", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deleteOrthoMask(socket, id)
            store.dispatch(deleteEntitySocket({ path: ["orthoMasks", { id }] }))
        })

export {
    createAction as createOrthoMask,
    updateAction as updateOrthoMask,
    deleteAction as deleteOrthoMask,
}
